module.exports = __webpack_public_path__ + "lp/img/folder_icon_list.11ad1ed9.svg";